import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Button from '@material-ui/core/Button';

const propTypes = {
  filename: PropTypes.string.isRequired,
  CACertId: PropTypes.string.isRequired,
  getInstanceCertificateDownload: PropTypes.func.isRequired,
  service: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledCADownloadLink({
  filename,
  CACertId,
  service,
  instanceId,
  classes,
  getInstanceCertificateDownload,
}) {
  const createDownloadFile = () => {
    getInstanceCertificateDownload(service.toLowerCase(), instanceId, CACertId)
      .then((data) => {
        if (data.payload.certificate) {
          const element = document.createElement('a');
          element.download = `${filename}.crt`;
          element.style = 'display: none;';
          const file = new Blob([data.payload.certificate], { type: 'text/plain;charset=utf-8;' }); // eslint-disable-line no-undef
          element.href = window.URL.createObjectURL(file);
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        }
      })
      .catch((error) => error);
  };

  return (
    <Button
      component="a"
      disableFocusRipple
      disableRipple
      onClick={createDownloadFile}
      href="#"
      classes={{ root: classes.button }}
    >
      Download Certification Authority
    </Button>
  );
}

UnstyledCADownloadLink.propTypes = propTypes;

const styles = () => ({
  button: {
    fontSize: '.857rem',
    fontFamily: ['"Roboto"', 'sans-serif'].join(','),
    fontWeight: 400,
    background: 'none!important',
    color: 'rgb(0, 0, 238)',
    border: 'none',
    padding: '0!important',
    textTransform: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: 'rgb(0, 100, 238)',
      background: 'none',
      textDecoration: 'underline',
    },
    '&:visited': {
      color: 'purple',
    },
  },
});

export default withStyles(styles)(UnstyledCADownloadLink);
